/* eslint-disable no-throw-literal */
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { CONFIG_APP, VAPID_KEY } from 'config/firebase';
import PushNotificationActions from './push_notification_actions';

const configureFirebase = () => {
  if (!('Notification' in window)) throw 'Este navegador não possui suporte à notificações';

  if ('Notification' in window && 'serviceWorker' in navigator) {
    initializeApp(CONFIG_APP);

    const messaging = getMessaging();

    Notification.requestPermission().then((permission) => {
      if (permission === 'granted')
        getToken(messaging, { vapidKey: VAPID_KEY }).then((token) =>
          PushNotificationActions.savePermissionToken(token),
        );
    });

    onMessage(messaging, (payload) => {
      if (!payload) return;

      const notificationConfig = {
        body: payload.notification?.body,
        title: payload.notification?.title,
        click_action: payload.data?.click_action,
        icon: payload.data?.icon,
        requireInteraction: false,
        silent: false,
      };

      const notification = new Notification(
        payload.notification?.title as string,
        notificationConfig,
      );
      notification.onclick = (event) => {
        event.preventDefault();
        if (!payload.data?.click_action) return;

        window.location.href = payload.data?.click_action as string;
      };
    });
  }
};

export default configureFirebase;
